import React, { FC } from 'react'
import { Button } from '../Button'
import { ButtonProps } from '@veneer/core/dist/scripts/button/types'
import { useExitCallback } from '../../../hooks/useExitCallback'

type ExitButtonProps = {
  'data-analyticsid': string
  appearance: string
  result: string
  reminder?: boolean
  testid?: string
  screenName?: string
  disabled?: boolean
  errorCode?: string
  errorDescription?: string
}

export const ExitButton: FC<ExitButtonProps & ButtonProps> = ({
  'data-analyticsid': dataAnalyticsid,
  appearance,
  result,
  reminder = false,
  testid = undefined,
  screenName = undefined,
  disabled = false,
  errorCode = undefined,
  errorDescription = undefined,
  children
}) => {
  const { onContinue, loading } = useExitCallback({
    result,
    reminder,
    screenName,
    errorCode,
    errorDescription
  })

  return (
    <Button
      className={`${
        appearance === 'secondary'
          ? 'instant-ink-enroll-hpx-secondary-button-override'
          : ''
      } ${disabled ? 'instant-ink-enroll-hpx-button-override' : ''}`}
      data-analyticsid={dataAnalyticsid}
      appearance={appearance}
      onClick={onContinue}
      loading={loading}
      data-testid={testid}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}
